var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorMark = function SvgErrorMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    width: 60,
    height: 60
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 30C3.333 15.272 15.272 3.333 30 3.333S56.667 15.272 56.667 30 44.728 56.667 30 56.667 3.333 44.728 3.333 30",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 42.5c0 .69-.244 1.28-.732 1.768S30.69 45 30 45s-1.28-.244-1.768-.732S27.5 43.19 27.5 42.5s.244-1.28.732-1.768S29.31 40 30 40s1.28.244 1.768.732.732 1.077.732 1.768l-.002.087",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.942 17.442v16.783",
    strokeLinecap: "square",
    fill: "none"
  })));
};
export default SvgErrorMark;